function formatStorageSize(val) {
  return Math.round((val ?? 0) / 1024 / 1024 / 1024 * 1000) / 1000; // eslint-disable-line
}

export default {
  namespaced: true,
  state: () => ({
    user: null,
    routeAfterSuccessfulLogin: null,
  }),
  getters: {
    userMaxProjects: (state) => state.user?.tariff.maxProjects,
    userProjectCount: (state) => state.user?.projectCount,
    userMaxStorage: (state) => formatStorageSize(state.user?.tariff.maxStorage),
    userStorageCount: (state) => formatStorageSize(state.user?.storageCount),
  },
  mutations: {
    setUser(state, payload) {
      state.user = payload;
    },
    setRouteAfterSuccessfulLogin(state, payload) {
      state.routeAfterSuccessfulLogin = payload;
    },
  },
  actions: { },
};
